import { useCallback, useEffect, useState } from "react";
import { workoutSyncEngine } from "../sync/syncEngine";

const EMPTY_STATUS = Object.freeze({
  pendingCount: 0,
  states: [],
  lastError: null,
  syncingExecutionIds: [],
});

export default function useSyncStatus(userId, { engine = workoutSyncEngine } = {}) {
  const [status, setStatus] = useState(EMPTY_STATUS);

  useEffect(() => {
    let active = true;
    let latestRequest = 0;
    const refresh = () => {
      // Only the newest read may land: an older read resolving late would
      // otherwise leave a finished push displayed as still syncing.
      latestRequest += 1;
      const request = latestRequest;
      engine.getStatus(userId).then((next) => {
        if (active && request === latestRequest) setStatus(next);
      }).catch((error) => {
        if (active && request === latestRequest) setStatus({ ...EMPTY_STATUS, lastError: error });
      });
    };
    refresh();
    const unsubscribe = engine.subscribe(refresh);
    return () => {
      active = false;
      unsubscribe();
    };
  }, [engine, userId]);

  const syncNow = useCallback(() => engine.syncNow(userId), [engine, userId]);
  return { ...status, syncNow };
}
